import moment from 'moment-timezone';
import { useQuery } from '@tanstack/react-query';
import { useNetworkRequest } from './useNetworkRequest';

const DEFAULT_IMMEDIATE_WINDOW_HOURS = 72;

const startsWithinWindow = (startsTime: string) => {
  const timeThreshold = moment().add(DEFAULT_IMMEDIATE_WINDOW_HOURS, 'hours');
  return moment(startsTime).isBefore(timeThreshold);
};

export const useImmediateExpiringConditions = (
  currentStartsTime?: string | null,
  jobId?: number | null,
) => {
  const { axios } = useNetworkRequest();
  const enabled = currentStartsTime ? startsWithinWindow(currentStartsTime) : false;

  const fetchImmediateExpiringConditionIds = async (
    jobId?: number | null,
  ): Promise<Array<number>> => {
    const {
      data: { condition_ids: ids },
    } = await axios.post(`/v3/professional/jobs/${jobId}/immediate_expiring_condition_ids`);

    return ids;
  };

  // TODO: Better understand the cost of this query and when to re-fire it CORE-4518
  const { data, isLoading, refetch } = useQuery({
    enabled,
    queryKey: ['fetchImmediateExpiringConditionIds', jobId],
    queryFn: () => fetchImmediateExpiringConditionIds(jobId),
  });

  return {
    immediateExpiringConditionIds: data ?? [],
    isLoading: isLoading && enabled,
    refetch,
  };
};
